<template>
  <div class="flex-container">
    <div class="forgot-whitebox">
      <p class="pass-desc">
        Enter your email address to receive instruction for resetting your password.
      </p>
      <div class="forgot-container">
        <div class="forgot-input form-group col-sm-12">
          <label for="email">Email</label>
          <span class="required_astric">*</span>
          <input
            class="forgot-input-box required form-control"
            type="email"
            placeholder="E-mail Address"
            v-model="email"
          />
        </div>
      </div>
      <div class="col-sm-12 emergo-button">
        <button
          class="btn emergo-green-button"
          type="button"
          @click="postEmail"
          :disabled="disableButton"
        >
          {{ btnTxt }}
        </button>
      </div>
      <p class="footer-desc">
        Contact RAMS Support at <a href="mailto:ramshelp@ul.com">ramshelp@ul.com</a> in case if
        didn't receive the email to reset password.
      </p>
    </div>
  </div>
</template>
<script>
import { postForgotEmail } from '../../apis/passwords';
import { isValidMail } from '../Register/validator';

export default {
  data() {
    return {
      email: '',
      enableBtn: true,
      btnTxt: 'Email Instructions'
    };
  },
  methods: {
    async postEmail() {
      this.btnTxt = 'Submitting Form...';
      const result = await postForgotEmail({ email: this.email });
      if (result && result.status) {
        this.$router.push('/login');
      } else if (!result.status) {
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: result.message,
          group: 'custom-notification'
        });
      }
      this.btnTxt = 'Email Instructions';
    }
  },
  computed: {
    disableButton() {
      if (isValidMail(this.email)) {
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin emergoGreenBtnProps {
  background: $light-green !important;
  border-color: $light-green !important;
  color: $deep-white !important;
  outline: none;
}
.flex-container {
  text-align: center;
  background-image: url(/static/images/logos/World_Map_Login.svg);
  background-repeat: no-repeat;
  background-size: 100%;
}
.forgot-whitebox {
  background: $deep-white;
  border: 0.8px solid $gray74;
  border-radius: $radius10;
  max-width: 450px;
  min-width: 450px;
  margin-top: 25px;
  margin-bottom: 25px;
}
.forgot-container {
  font-size: $font-16;
  position: relative;
  padding-bottom: 10px;
}
.forgot-input {
  &.form-group {
    font-size: $font-14;
    line-height: 16px;
    text-align: left;
    margin-bottom: 40px;
    padding: 0px 32px;
  }
}
.forgot-input-box {
  font-size: $font-16;
  line-height: 19px;
  color: $dark-black-alpha;
  padding: 9px 35px 9px 16px;
}
.pass-desc {
  font-style: normal;
  @include fontItems($font-18, 21px, $font-weight-400);
  color: $dark-black-alpha;
  margin: 40px 32px 32px 32px;
  text-align: left;
}
.form-group {
  label {
    padding-right: 5px;
  }
}
.required_astric {
  color: $deep-thick-danger;
}
.footer-desc {
  font-style: normal;
  @include fontItems($font-16, 21px, $font-weight-400);
  color: $dark-black-alpha;
  margin-bottom: 40px;
  text-align: center;
  padding: 0px 32px;
  a {
    font-weight: 700;
    color: $messenger-blue;
  }
}
.btn {
  padding: 7px 30px;
}
.emergo-button {
  padding: 0px 32px 32px 32px;
}
.emergo-green-button {
  padding: 7px 30px;
  width: 100%;
}
.emergo-green-button {
  &:hover {
    &:not(:disabled) {
      @include emergoGreenBtnProps();
    }
  }
  &:active,
  &.active {
    &:hover {
      &:not(:disabled) {
        @include emergoGreenBtnProps();
      }
    }
  }
  &:focus {
    @include emergoGreenBtnProps();
  }
}

@media screen and (max-width: 767px) {
  .flex-container {
    padding: 0px 30px;
  }
  .forgot-whitebox {
    min-width: 85vw !important;
  }
}
@media (min-width: 768px) and (max-width: 820px) {
  .flex-container {
    min-height: 70vh;
  }
}
@media only screen and (max-width: 991px) {
  .flex-container {
    background-size: unset;
  }
}
@media (min-width: 2049px) and (max-width: 2732px) {
  .flex-container {
    min-height: 70vh;
  }
}
</style>
